<template>
  <div class="tencent-iframe">
    <iframe :src="url" style="border:none" width="100%" height="100%" ref="iframe"></iframe>
  </div>
</template>
<script>
export default {
  name: 'TencentUpload',
  data () {
    return {
      url: '',
    };
  },
  created () {
    const url = this.$route.query.url ? decodeURIComponent(this.$route.query.url) : '';
    this.url = url;
  },
};
</script>
<style lang="scss" scoped>
.tencent-iframe {
  height: calc(100vh - 130px);
}
</style>
